import { axios } from '../../services/axios';

export default async function createServiceProfiles({
    type,
    level,
    payload,
    scope,
}) {
    const result = await axios.post(
        `/serviceprofile/${type}/${level}`,
        payload,
        { _requestScopeOverride: scope },
    );
    return result;
}
